import React, { Component } from 'react';
import classNames from 'classnames';

export default class SearchForm extends Component {

    render() {
        const matches = this.props.matches;

        const searchFoundCount = matches.length;
        const searchString = this.props.searchQuery;
        const searchFocusIndex = this.props.searchFocusIndex;

        return (
            <form
                onSubmit={event => {
                    event.preventDefault();
                }}
            >
                <div className="form-group row">
                    <div className="col-sm-8">
                        <input
                            id="find-box"
                            type="text"
                            value={searchString}
                            onChange={e => this.props.onSearch(e.target.value)}
                            className={classNames("form-control")}
                            placeholder={'Søg...'}
                        />
                    </div>
                    <div className="col-sm-2">
                        <button
                            type="button"
                            disabled={!searchFoundCount}
                            onClick={() => this.props.selectPrevMatch(searchFoundCount)}
                            role="button"
                            className={classNames("btn")}
                        >
                            &lt;
                        </button>

                        <button
                            type="submit"
                            disabled={!searchFoundCount}
                            onClick={() => this.props.selectNextMatch(searchFoundCount)}
                            role="button"
                            className={classNames("btn", "ml-1")}
                        >
                            &gt;
                        </button>

                        <span className={classNames("font-weight-bold")}>
                  &nbsp;
                            {searchFoundCount > 0 ? searchFocusIndex + 1 : 0}
                            &nbsp;/&nbsp;
                            {searchFoundCount || 0}
                        </span>
                    </div>
                    <div className="col-sm-2">
                        <button
                            type="button"
                            onClick={() => this.props.clearSearch()}
                            role="button"
                            className={classNames("btn btn-primary pull-right")}
                        >
                            Nulstil
                        </button>
                    </div>
                </div>
            </form>
        );
    }
}


// WEBPACK FOOTER //
// ./web/src/components/categories/SearchForm.jsx